import React from 'react';
import { useTranslations } from '@lang';
import { Container } from './HurryMessage.styles';

type HurryMessageProps = {
  quantity: number;
  small?: boolean;
};

export function HurryMessage({ quantity, small = false }: HurryMessageProps) {
  const { t } = useTranslations();

  return <Container small={small}>{t('room.hurryMessage', { quantity })}</Container>;
}
